import { Controller, useFormContext } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

interface RHFDatePickerProps {
  name: string;
  label: string;
  helperText?: string;
  disabled?: boolean;
}

export default function RHFDatePicker({ name, label, helperText, disabled }: RHFDatePickerProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DatePicker
          label={label}
          value={field.value}
          onChange={(newValue) => {
            field.onChange(newValue);
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!error,
              helperText: error ? error?.message : helperText,
              disabled,
            },
          }}
        />
      )}
    />
  );
}